module.exports = __webpack_public_path__ + "static/text-5ec0c4139afa3b5bd650777e1a7a8286.png";